import { Directive, ElementRef, HostListener } from '@angular/core';
import { AbstractControl, NgControl } from '@angular/forms';

@Directive({
  selector: '[appVinNumber]',
})
export class VinNumberDirective {
  private element: HTMLInputElement;

  constructor(private el: ElementRef, private control: NgControl) {
    this.element = this.el.nativeElement;
  }

  @HostListener('input')
  public onKeyUp(): void {
    const formControl: AbstractControl | null = this.control.control;
    let value = this.element.value.toUpperCase();

    // Only accept numbers and letters
    if (value.match(/[^A-Za-z0-9]/g)) {
      value = value.replace(/[^A-Za-z0-9]/g, '');
    }

    // Max 17 chars
    if (value.length > 17) {
      value = value.substring(0, 17);
    }
    formControl?.setValue(value);
  }
}
